import { useGetLeagueGameQuery } from '@bo-services/leaguesApi';

export function useGame({
  gameId,
  leagueId
}: {
  gameId?: string;
  leagueId?: string;
}) {
  const {
    data: game,
    isError: isLeagueGameError,
    isFetching,
    isLoading
  } = useGetLeagueGameQuery(
    {
      gameId: gameId ?? '',
      leagueId: leagueId ?? ''
    },
    { skip: !gameId || !leagueId }
  );

  const isLeagueGameLoading = isLoading || isFetching;

  return {
    game,
    isLeagueGameError,
    isLeagueGameLoading
  };
}
